package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.MenubarDemo

@Page
@Composable
fun MenubarPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/menubar.md", mapOf("title" to listOf("Menubar"), "description" to listOf("A visually persistent menu common in desktop applications that provides quick access to a consistent set of commands."), "radix" to listOf(), "link" to listOf("https://www.radix-ui.com/docs/primitives/components/menubar"), "api" to listOf("https://www.radix-ui.com/docs/primitives/components/menubar#api-reference")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.*

val MenubarDemo = FC<Props> {
    Menubar {
        MenubarMenu {
            MenubarTrigger { +"File" }
            MenubarContent {
                MenubarItem {
                    +"New Tab"
                    MenubarShortcut { +"⌘T" }
                }
                MenubarItem {
                    +"New Window"
                    MenubarShortcut { +"⌘N" }
                }
                MenubarItem {
                    disabled = true
                    +"New Incognito Window"
                }
                MenubarSeparator {}
                MenubarSub {
                    MenubarSubTrigger { +"Share" }
                    MenubarSubContent {
                        MenubarItem {
                            +"Email"
                        }
                        MenubarItem {
                            +"Messages"
                        }
                        MenubarItem {
                            +"Notes"
                        }
                    }
                }
                MenubarSeparator {}
                MenubarItem {
                    +"Print..."
                    MenubarShortcut { +"⌘P" }
                }
            }
        }
        MenubarMenu {
            MenubarTrigger { +"Edit" }
            MenubarContent {
                MenubarItem {
                    +"Undo"
                    MenubarShortcut { +"⌘Z" }
                }
                MenubarItem {
                    +"Redo"
                    MenubarShortcut { +"⇧⌘Z" }
                }
                MenubarSeparator {}
                MenubarSub {
                    MenubarSubTrigger { +"Find" }
                    MenubarSubContent {
                        MenubarItem {
                            +"Search the web"
                        }
                        MenubarSeparator {}
                        MenubarItem {
                            +"Find..."
                        }
                        MenubarItem {
                            +"Find Next"
                        }
                        MenubarItem {
                            +"Find Previous"
                        }
                    }
                }
                MenubarSeparator {}
                MenubarItem {
                    +"Cut"
                }
                MenubarItem {
                    +"Copy"
                }
                MenubarItem {
                    +"Paste"
                }
            }
        }
        MenubarMenu {
            MenubarTrigger { +"View" }
            MenubarContent {
                MenubarCheckboxItem {
                    +"Always Show Bookmarks Bar"
                }
                MenubarCheckboxItem {
                    checked = true
                    +"Always Show Full URLs"
                }
                MenubarSeparator {}
                MenubarItem {
                    inset = true
                    disabled = true
                    +"Reload"
                    MenubarShortcut { +"⌘R" }
                }
                MenubarSeparator {}
                MenubarItem {
                    inset = true
                    +"Toggle Fullscreen"
                }
                MenubarSeparator {}
                MenubarItem {
                    inset = true
                    +"Hide Sidebar"
                }
            }
        }
        MenubarMenu {
            MenubarTrigger { +"Profiles" }
            MenubarContent {
                MenubarRadioGroup {
                    value = "benoit"
                    MenubarRadioItem {
                        value = "andy"
                        +"Andy"
                    }
                    MenubarRadioItem {
                        value = "benoit"
                        +"Benoit"
                    }
                    MenubarRadioItem {
                        value = "luis"
                        +"Luis"
                    }
                }
                MenubarSeparator {}
                MenubarItem {
                    inset = true
                    +"Edit..."
                }
                MenubarSeparator {}
                MenubarItem {
                    inset = true
                    +"Add Profile..."
                }
            }
        }
    }
}"""){ 
 MenubarDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Menubar
import shadcn.ui.components.MenubarContent
import shadcn.ui.components.MenubarItem
import shadcn.ui.components.MenubarMenu
import shadcn.ui.components.MenubarSeparator
import shadcn.ui.components.MenubarShortcut
import shadcn.ui.components.MenubarTrigger
""", lang= "kotlin", highlight= "")
            CodeBlock("""Menubar {
    MenubarMenu {
        MenubarTrigger { +"File" }
        MenubarContent {
            MenubarItem {
                + "New Tab "
                MenubarShortcut { +"⌘T" }
            }
            MenubarItem { + "New Window" }
            MenubarSeparator {}
            MenubarItem { + "Share" }
            MenubarSeparator {}
            MenubarItem { + "Print" }
        }
    }
}
""", lang= "kotlin", highlight= "")
        }
    }
}
